import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: center;
  gap: 6px;
  min-height: 179px;
  &.withLoading {
    opacity: 0;
  }
`;

/* Directional link between the two evidence cards: entry → exit. */
export const Connector = styled.div`
  flex-shrink: 0;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin: 0 2px;
  border-radius: 999px;
  color: #7a838a;
  background: #12171c;
  border: 1px solid #2c353d;

  svg {
    width: 22px;
    height: 22px;
    display: block;
  }
`;
